// One shared AudioContext for everything that makes sound (footsteps, the
// whistle, the daytime birdsong). Browsers block audio until a user gesture,
// so unlockAudio() is called from the same click that requests pointer lock.

let ctx = null

export function getCtx() {
  if (typeof window === 'undefined') return null
  if (!ctx) {
    try {
      const AC = window.AudioContext || window.webkitAudioContext
      if (!AC) return null
      ctx = new AC()
    } catch {
      return null
    }
  }
  return ctx
}

export function unlockAudio() {
  const c = getCtx()
  if (c && c.state === 'suspended') c.resume().catch(() => {})
}

export function audioReady() {
  const c = getCtx()
  return !!c && c.state === 'running'
}

/**
 * Fetch + decode an audio file into a buffer, trying each URL in turn (so an
 * .ogg can fall back to .wav on browsers that won't decode it). Returns null
 * rather than throwing: sound is never worth breaking the world over.
 */
export async function loadBuffer(urls) {
  const c = getCtx()
  if (!c) return null
  for (const url of [].concat(urls)) {
    try {
      const res = await fetch(url)
      if (!res.ok) continue
      const bytes = await res.arrayBuffer()
      return await c.decodeAudioData(bytes)
    } catch {
      // try the next candidate
    }
  }
  return null
}
